
import {Country} from '../models/country';
import {Platform} from '../models/platform';
import {Project} from './project/project';
import {AudienceFilter} from './discover';

export class Industry {
  id: number;
  name: string;
  description: string;
}

export class Topic {
  id: number;
  name: string;
  description: string;
}

export class Gender {
  id: number;
  name: string;
}

export class InfluencerSideBar {
  influencer_group_id: number;
  name: string;
  influencers: any[];
  visible: string;
}

export class DiscoverFilterBar {
  countries: Array<Country>;
  genders: Array<Gender>;
  platforms: Array<Platform>;
  influencers: Array<InfluencerSideBar>;
  projects: Array<Project>;
  topics: Array<Topic>;
  industries: Array<Industry>;
  // activity filter
  reachFrom: number;
  reachTo: number;
  engagementFrom: number;
  engagementTo: number;
  impactFrom: number;
  impactTo: number;
}

export class FilterSearch {
  mentions: Array<string> = [];
  countries: Array<number> = [];
  genders: Array<number> = [];
  platforms: Array<number> = [];
  influencers: Array<number> = [];
  projects: Array<number> = [];
  period: number;
  orderBy: string | null;
  reachFrom: number = null;
  reachTo: number = null;
  engagementFrom: number = null;
  engagementTo: number = null;
  impactFrom: number = null;
  impactTo: number = null;
  followerFrom: number = null;
  followerTo: number = null;
  // audience filter
  audienceFilters: Array<any> = [];
  // interest filter
  interestFilters: Array<any> = [];
  limit: number;
  offset: number;
  searchAfter: Array<any> = [];
}

export class InterestFilter {
  public topics: Array<number> = [];
  public industries: Array<number> = [];
}

export class ActivityFilter {
  reachFrom: number = null;
  reachTo: number = null;
  engagementFrom: number = null;
  engagementTo: number = null;
  impactFrom: number = null;
  impactTo: number = null;
  followerFrom: number = null;
  followerTo: number = null;
  constructor(reachFrom, reachTo, engagementFrom, engagementTo, impactFrom, impactTo, followerFrom, followerTo) {
    this.reachFrom = reachFrom;
    this.reachTo = reachTo;
    this.engagementFrom = engagementFrom;
    this.engagementTo = engagementTo;
    this.impactFrom = impactFrom;
    this.impactTo = impactTo;
    this.followerFrom = followerFrom;
    this.followerTo = followerTo;
  }
}



// WEBPACK FOOTER //
// ./src/models/filter-search.ts